export function formatRub(kop: number): string {
  const rub = (kop / 100).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `${rub} ₽`;
}

export function formatDate(iso: string | Date, opts: Intl.DateTimeFormatOptions = {}): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return d.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...opts,
  });
}

export const roleLabels: Record<string, string> = {
  CLIENT: 'Клиент',
  CASHIER: 'Кассир',
  ADMIN: 'Администратор',
  OWNER: 'Владелец',
  WAITER: 'Официант',
};

export const orderStatusLabels: Record<string, string> = {
  NEW: 'Новый',
  IN_PROGRESS: 'В работе',
  READY: 'Готов',
  COMPLETED: 'Завершён',
  CANCELLED: 'Отменён',
};

export const paymentMethodLabels: Record<string, string> = {
  CASH: 'Наличные',
  CARD: 'Карта',
  TRANSFER: 'Перевод',
  QRCODE: 'QR-код',
  MIXED: 'Смешанная',
  ONLINE: 'Онлайн (приложение)',
};
